import axios from 'axios'
import { config } from "../Config/config"

const pengalamanDoctor = {
    getAllPengalaman: () => {
        const result = axios.get(config.apiUrl + '/Doctor_pengalaman')
        //ketika berhasil 
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        //untuk pesan errornya
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    

}

export default pengalamanDoctor